import environment from "@/modules/environment";

export const getVideoFiles = () => {
  const barkioImport = () => import.meta.glob<{ default: string }>("@/assets/barkio/*.{webm,mp4,}", { eager: true });
  const bibinoImport = () => import.meta.glob<{ default: string }>("@/assets/bibino/*.{webm,mp4,}", { eager: true });
  const cameritoImport = () =>
    import.meta.glob<{ default: string }>("@/assets/camerito/*.{webm,mp4,}", { eager: true });

  switch (environment.appName) {
    case "barkio":
      return barkioImport();
    case "bibino":
      return bibinoImport();
    case "camerito":
      return cameritoImport();
  }
};
